// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__-50rn","tabs":"LayoutWrapperSideNav_tabs__1YgCH","tab":"LayoutWrapperSideNav_tab__3_B6f"};